export default __webpack_public_path__ + "static/media/1.9ce09c09.png";